export const FallbackError = () => {
  return (
    <div className="flex flex-col w-full h-full items-center p-8">
      <h1 className="text-2xl font-bold text-gray-700">Error</h1>
      <div className="text-base text-gray-700">Uh-oh! Something went wrong!! Try again.</div>
    </div>
  );
};
